"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fendtCommonColorsDeviation = {
    grays: {
        50: '#FCFCFC',
        100: '#F7F7F7',
        200: '#EBEBEB',
        300: '#E5E5E5',
        400: '#D9D9D9',
        500: '#CCCCCC',
        600: '#B2B2B2',
        700: '#808080',
        800: '#4C4C4C',
        900: '#2A2A2A',
    },
    warning: {
        100: '#F3DCB2',
        500: '#DB9110',
        900: '#266611',
    },
};
exports.default = fendtCommonColorsDeviation;
